<template>
    <section>
        <div class="container">
            <h2 class="pb-4">{{ titulo != null ? titulo : this.title != null ? this.title : '' }}</h2>
            <div class="row row-cols-1 g-4">
                <div class="col" v-for="(el,index) in items" :key="index">
                    <div class="card">
                        <div class="card-body p-md-1 d-flex flex-md-row align-items-md-center flex-column">
                            <div
                                class="contenedor-icono d-inline-flex align-items-center justify-content-center flex-shrink-0 me-3">
                                <svg class="ptn-i-documento text-ptn-color-gsj-2" v-if="!el.icon">
                                    <use xlink:href="#ptn-i-documento"></use>
                                </svg>
                                <svg class="ptn-i-documento text-ptn-color-gsj-2" v-if="el.icon">
                                    <use v-bind="{'xlink:href' : '#' + el.icon }"></use>
                                </svg>
                            </div>
                            <p class="card-text m-md-0" style="min-width: 90px;" v-if="showFecha">{{ el.fecha }}</p>
                            <h3 class="card-title m-md-0 px-md-4 h6 text-uppercase">
                                <a v-bind:href="el.url" v-bind:target="el.target ? el.target : '_self'" class="stretched-link">{{ el.title }}</a>
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "DocumentListComponent",
    props: {
        titulo: String,
        items: Array,
        showFecha: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            title: null,
        };
    },
    mounted() {
        this.title = this.titulo || '';
    },
};
</script>
